import {inject, Injectable} from '@angular/core';
import {environment} from '../../../../../environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IUser, IUserList} from '../../../shared/model/user.model';

export type EntityArrayResponseType = HttpResponse<IUserList>;
export type EntityResponseType = HttpResponse<IUser>;

@Injectable({
  providedIn: 'root'
})
export class InternService {
  private apiUser = `${environment.wsApiBaseUrl}/api/user`
  protected readonly http = inject(HttpClient);

  findAll(params: any): Observable<EntityArrayResponseType> {
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value === null || value === undefined || value === "") delete params[key];
    });
    return this.http.get<IUserList>(`${this.apiUser}`, {observe: 'response', params });
  }

  findById(id: number): Observable<EntityResponseType> {
    return this.http.get<IUser>(`${this.apiUser}/${id}`, {observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.apiUser}/${id}`, {observe: 'response'});
  }

  update(user: IUser): Observable<EntityResponseType> {
    return this.http.put<IUser>(`${this.apiUser}`, user, {observe: 'response'});
  }

  save(user: IUser): Observable<EntityResponseType> {
    return this.http.post<IUser>(`${this.apiUser}`, user, {observe: 'response'});

  }

}
